import PropTypes from 'prop-types'

const BASE_CLASS = 'mt-HeroBasic'

const HeroBasicExtraInfo = ({label, icon}) => {
  const hasIcon = typeof icon === 'object'
  return (
    <span className={`${BASE_CLASS}-extraInfo`}>
      {hasIcon && icon}
      {label}
    </span>
  )
}

HeroBasicExtraInfo.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.node
}

export default HeroBasicExtraInfo
